import * as Type from './actionsTypes';

const INITIAL_STATE = {
  selectedPedidoVoo: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.PEDIDO_VOO_VALIDATE_SUCCESS:
    case Type.PEDIDO_VOO_FIND_ONE_SUCCESS:
    case Type.PEDIDO_VOO_UPDATE_SUCCESS:
    case Type.PEDIDO_VOO_SAVE_SUCCESS: {
      return {
        ...state,
        selectedPedidoVoo: action.data,
      };
    }
    case Type.PEDIDO_VOO_CLEAR_SELECTED: {
      return {
        ...state,
        selectedPedidoVoo: {},
      };
    }
    case Type.PEDIDO_VOO_CLEAN: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

export const getSelectedPedidoVoo = state => state.rootState.pedidoVoo.selectedPedidoVoo;
